(function () {
  var QUERY = '(min-width: 990px)';

  function syncRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var desktop = window.matchMedia(QUERY).matches;
    var detailsList = root.querySelectorAll('.seo-accordion-columns__details');
    detailsList.forEach(function (details, index) {
      if (desktop) {
        details.setAttribute('open', '');
      } else if (index === 0) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-seo-accordion-root]').forEach(syncRoot);
  }

  if (!window.__seoAccordionColumnsBound) {
    window.__seoAccordionColumnsBound = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    var mq = window.matchMedia(QUERY);
    if (mq.addEventListener) {
      mq.addEventListener('change', initAll);
    } else if (mq.addListener) {
      mq.addListener(initAll);
    }
    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (!target || !target.querySelector) return;
      var root = target.querySelector('[data-seo-accordion-root]');
      if (root) syncRoot(root);
    });
  } else {
    initAll();
  }
})();
